import { ReactComponent as ArrowLeft } from '../../../asserts/icons/longArrowLeft.svg'
import css from './backButton.module.css'
import { useNavigate } from 'react-router'

interface IProps {
  onClick?: () => void
}

const BackButton = (props: IProps) => {
  const navigate = useNavigate()

  return (
    <div className={css.container} onClick={props.onClick || (() => navigate(-1))}>
      <ArrowLeft />
    </div>
  )
}

export default BackButton
